<template>
  <div class="wrapper login">
    <el-card
      shadow="always"
      class="card"
      v-loading="loadingGoogleSignIn || loadingSSO"
      :body-style="{ 'text-align': 'center' }"
    >
      <div class="img-wrapper">
        <img :src="logo_url" alt="Hk-Logo" />
      </div>
      <div v-if="!showChangePassword">
        <div v-if="disable_manual_login === 'false'">
          <el-form
            :model="credentials"
            status-icon
            :rules="rules"
            ref="login"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item label="" prop="username">
              <el-input
                v-model="credentials.username"
                class="input"
                type="text"
                placeholder="Username"
                clearable=""
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
              <el-input
                @keyup.enter="login"
                v-model="credentials.password"
                class="input"
                type="password"
                placeholder="Password"
                clearable=""
              ></el-input>
            </el-form-item>
            <div v-if="recaptcha_show === 'true'">
              <RecaptchaV2
                name="recaptcha"
                ref="recaptcha"
                @verify="onVerify"
                :sitekey="site_key"
              />
            </div>
            <el-button :loading="loading" @click="login" class="button" type="primary"
              >Login</el-button
            >
            <div class="or" v-if="isDefaultPoolCode === 'true'">
              <hr />
              <div>OR</div>
            </div>
          </el-form>
        </div>

        <template v-if="isDefaultPoolCode">
          <el-button @click="loginWithCognito" class="button g-sign-in-btn" type="primary">Login with SSO</el-button>
          <!--          <template v-else>
            <g-sign-in-button
                              @google-button-clicked="loadingGoogleSignIn=true"
                              :params="googleSignInParams"
                              @success="onSignInSuccess"
                              @error="onSignInError">
              <img src="@/assets/logos/google_hotelkey_logo.png" alt=""
                   style="height: 20px; max-width: 25px; margin: 0 5px 0 0">
              Login with HotelKey Google Account
            </g-sign-in-button>
          </template>-->
        </template>

        <div class="or" style="margin-top: 30px" v-if="SSO_in_use && google_sign_in === 'true'">
          <hr />
          <div>OR</div>
        </div>
        <template v-if="SSO_in_use">
          <el-button :loading="loadingSSO" @click="loginWithSSO()" class="button" type="primary"
            >Login with SSO
          </el-button>
        </template>
        <el-alert
          v-if="loginError"
          :title="loginError.message || loginError"
          type="error"
          :closable="false"
          show-icon
        >
        </el-alert>
      </div>
      <change-password
        v-if="showChangePassword"
        :password-user-id="new_password_user_id"
        :error-token="error_token"
        :error-info="error_info"
        @close="showChangePassword = false"
      />
    </el-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import actions from '@/store/action_types'
import mutations from '@/store/mutation_types'
import { RecaptchaV2 } from 'vue3-recaptcha-v2'
import axios from 'axios'
import { am_I_atLocalhost, generateUUID } from '@/common/utils'
import * as CryptoJS from 'crypto-js'
import base64url from 'base64url'
import ChangePassword from '@/views/login/ChangePassword'
import Global from '@/common/global.service'
import  { Buffer }  from 'buffer'


import { RouteStore } from "@/store/routeStore.js";
export default {
  name: 'login',
  components: {
    RecaptchaV2,
    ChangePassword
  },
  mounted() {

    if (this.user) {
      this.routeStore.hkRouterPush('home')
    }

  },
  data() {
    return {
      logo_url: window.hkConfigEnvs.VUE_APP_LOGO,
      disable_manual_login: window.hkConfigEnvs.VUE_APP_DISABLE_MANUAL_LOGIN,
      loadingGoogleSignIn: false,
      loading: false,
      loadingSSO: false,
      credentials: {
        username: null,
        password: null
      },

      loginError: null,
      googleSignInParams: {
        client_id: window.hkConfigEnvs.VUE_APP_GOOGLE_CLIENT_ID,
        hosted_domain: 'hotelkeyapp.com'
      },
      recaptcha_status: null,
      site_key: window.hkConfigEnvs.VUE_APP_RECAPTCHA_SITE_KEY,
      google_sign_in: window.hkConfigEnvs.VUE_APP_GOOGLE_LOGIN_STATUS,
      SSO_in_use: window.hkConfigEnvs.VUE_APP_OAUTH_AUTH_URL === 'true',
      recaptcha_show: window.hkConfigEnvs.VUE_APP_RECAPTCHA_STATUS,
      showChangePassword: false,
      new_password_user_id: null,
      error_token: null,
      error_info: null,

      rules: {
        username: [{ required: true, message: 'Field is required', trigger: 'change' }],
        password: [{ required: true, message: 'Field is required', trigger: 'change' }]
      },
      routeStore: RouteStore()
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.current.user,
      property: (state) => state.current.property,
      hk_info: (state) => state.current.hk_info
    }),
    isDefaultPoolCode() {
      return this.poolCode
    },
    poolCode() {
      const configPool = window.hkConfigEnvs.VUE_APP_DEFAULT_POOL_CODE
      const rawQueryPool = this.$route.query['pool_code']
      const queryPool = typeof rawQueryPool === 'string' ? rawQueryPool.trim() : ''
      return queryPool && queryPool !== configPool ? queryPool : configPool
    }
  },
  methods: {
    ...mapActions([actions.login]),
    ...mapMutations([
      mutations.SET_CURRENT_USER,
      mutations.SET_HK_TOKEN,
      mutations.SET_HK_INFO,
      mutations.SET_GOOGLE_LOGIN,
      mutations.SET_TOKEN_EXPIRY_DATE,
      mutations.SET_ENTERPRISE_PERMISSIONS
    ]),
    getSessionId() {
      const random72CharString = generateUUID() + generateUUID()
      localStorage.setItem('CodeVerifier', random72CharString)
      const sha266OfRandom = CryptoJS.SHA256(random72CharString)
      const buffer = Buffer.from(sha266OfRandom.toString(CryptoJS.enc.Hex), 'hex')
      let arrayOfBuffer = new Uint8Array(buffer)
      let sessionId = base64url.encode(arrayOfBuffer)
      sessionId = encodeURIComponent(sessionId.replace('=', ''))
      document.cookie = `hk_session_id=${sessionId}`
      if (am_I_atLocalhost()) document.cookie = `hk_session_id=${sessionId}`
      else localStorage.setItem('hk_session_id', sessionId)
      return sessionId
    },
    loginWithCognito() {
      this.loadingGoogleSignIn = true
      let sessionId = this.getSessionId()

      let params = {
        // username: this.credentials.username,
        code: this.poolCode,
        session_id: sessionId,
        state: 'HK_HOME'
      }

      Global.getCognito(params).then((res) => {
        this.loadingGoogleSignIn = true
        window.location.href = res.data.redirect_url
      })
    },
    login() {
      this.$refs['login'].validate((valid) => {
        if (valid) {
          this.loading = true

          if (
            (this.recaptcha_status === null || this.recaptcha_status === false) &&
            this.recaptcha_show === 'true'
          ) {
            this.$notify({
              title: 'Warning',
              message: 'Please solve the recaptcha first',
              type: 'warning'
            })
            this.loading = false
          } else {
            this[actions.login]({
              username: this.credentials.username,
              password: this.credentials.password
            })
              .then(() => {
                this[mutations.SET_GOOGLE_LOGIN](false)
                this.routeStore.hkRouterPush({ name: 'home' })
              })
              .catch((error) => {
                this.handleLoginError(error)
              })
              .finally(() => {
                this.loading = false
              })
          }
        } else {
          return false
        }
      })
    },
    loginWithSSO() {
      this.loadingSSO = true
      try {
        const random72CharString = generateUUID() + generateUUID()
        localStorage.setItem('CodeVerifier', random72CharString)
        const sha266OfRandom = CryptoJS.SHA256(random72CharString)
        const buffer = Buffer.from(sha266OfRandom.toString(CryptoJS.enc.Hex), 'hex')
        let arrayOfBuffer = new Uint8Array(buffer)
        let codeQuery = base64url.encode(arrayOfBuffer)
        codeQuery = encodeURIComponent(codeQuery.replace('=', ''))

        if (am_I_atLocalhost()) document.cookie = `hk_session_id=${codeQuery}`
        else localStorage.setItem('hk_session_id', codeQuery)
        const urlToRedirect = `${window.hkConfigEnvs.VUE_APP_ENTERPRISE_URL}/${window.hkConfigEnvs.VUE_APP_CORE_API}/account/signin/init?session_id=${codeQuery}`
        window.location.href = urlToRedirect
      } catch (error) {
        console.error(error)
        this.loadingSSO = false
        this.$notify.error({
          title: 'Error',
          message: 'Please try again'
        })
      }
    },
    onVerify(res) {
      axios
        .post(
          `${window.hkConfigEnvs.VUE_APP_BASE_URL_API}/${window.hkConfigEnvs.VUE_APP_CORE_API}/check-captcha?g_recaptcha=${res}`
        )
        .then((res) => {
          if (res.data.status === false) {
            this.recaptcha_status = false
            this.$refs('recaptcha').recaptcha.reset()
            this.showAlert = true
            setTimeout(() => {
              if (this.showAlert === true) {
                this.showAlert = false
              }
            }, 5300)
          } else {
            this.recaptcha_status = true
          }
        })
        .catch((err) => {
          console.error(err)
          this.$refs.recaptcha.reset()
        })
    },
    handleLoginError(error) {
      switch (error?.response?.status) {
        case 401: {
          this.loginError = 'User password is incorrect'
          break
        }
        case 400: {
          this.loginError = 'Invalid Request'
          break
        }
        case 404: {
          this.loginError = 'Resource not found'
          break
        }
        case 426: {
          let token = error.response.config.headers
          this.new_password_user_id = error.response.data.user_id
          this.error_token = token['hk-token']
          this.error_info = token['hk-info']
          this.showChangePassword = true
          break
        }
        case 303: {
          this.routeStore.mfaState = {
            ...error.response.data,
            username: this.credentials.username,
            password: this.credentials.password,
            firstTime: true
          }
          this.routeStore.hkRouterPush({ name: 'qr-code' })
          break
        }
        case 450: {
          this.routeStore.mfaState = {
            ...error.response.data,
            username: this.credentials.username,
            password: this.credentials.password,
            firstTime: false
          }
          this.routeStore.hkRouterPush({ name: 'qr-code' })
          break
        }
        case 451: {
          this.routeStore.mfaState = {
            ...error.response.data,
            username: this.credentials.username,
            password: this.credentials.password,
            firstTime: false
          }
          this.routeStore.hkRouterPush({ name: 'qr-code' })
          break
        }
        case 500:
        case 502:
        case 503: {
          this.loginError = 'Server Error'
          break
        }
        default: {
          this.loginError = error?.response?.data
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$blue: #46a0fc;

.login {
  :deep(.el-form-item__content) {
    margin-left: 0px !important;
  }

  .el-form {
    .el-form-item {
      margin-bottom: 10px;
    }
  }
}

.card {
  max-width: 380px;
  margin: 60px auto 0 auto;


  img {
    height: 96px;
    margin-bottom: 10px;
  }

  .input {
    margin: 10px 0 auto;
  }

  .button {
    width: 100%;
    margin: 10px 0;
  }

  .or {
    position: relative;
    margin-top: 20px;

    hr {
      margin-top: 21px;
      margin-bottom: 21px;
      border: 0;
      border-top: 1px solid #eee;
    }

    div {
      font-size: 12px;
      position: absolute;
      font-weight: 400;
      left: 42%;
      padding: 0 20px;
      background: #fff;
      top: -8px;
    }
  }

  .g-sign-in-btn {
    padding: 12px 20px !important;
    font-size: 14px !important;
    height: 41px !important;
     box-shadow: 0 2px 6px #ccc !important;
  }
}

.img-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}
</style>
